function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -182.412)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.8,182.842a7.8,7.8,0,1,1-9.917,4.843,7.8,7.8,0,0,1,9.917-4.843Z",
  transform: "translate(-26.94 0)",
  className: "accent",
  fill: "#f7e842",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 186.65)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.285,219.5a1.926,1.926,0,0,0-.287.014h0a4,4,0,0,0-5.778-3.564A5.749,5.749,0,0,0,9.687,211.9a5.818,5.818,0,0,0-5.806,5.806,3.5,3.5,0,0,0,.014.388,2.817,2.817,0,1,0-1.078,5.418H21.285a2,2,0,0,0,0-4.01Zm0,3.306H2.817a2.12,2.12,0,0,1,0-4.24,2.188,2.188,0,0,1,1.322.446.345.345,0,0,0,.4.014.349.349,0,0,0,.158-.374,4.572,4.572,0,0,1-.1-.963,5.1,5.1,0,0,1,10.075-1.135.336.336,0,0,0,.216.244.385.385,0,0,0,.331-.029,3.3,3.3,0,0,1,5.1,2.745,3.825,3.825,0,0,1-.029.431.337.337,0,0,0,.144.316.369.369,0,0,0,.345.043,1.232,1.232,0,0,1,.517-.1,1.288,1.288,0,0,1,1.294,1.294A1.322,1.322,0,0,1,21.285,222.809Z",
  transform: "translate(0 -211.9)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.971,304.2H22.845a.345.345,0,1,0,0,.69h16.14a.34.34,0,0,0,.345-.345A.353.353,0,0,0,38.971,304.2Z",
  transform: "translate(-19.266 -290.934)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.971,324.3H22.845a.34.34,0,0,0-.345.345.35.35,0,0,0,.345.345h16.14a.34.34,0,0,0,.345-.345A.353.353,0,0,0,38.971,324.3Z",
  transform: "translate(-19.266 -308.146)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.971,344.6H22.845a.345.345,0,0,0,0,.69h16.14a.34.34,0,0,0,.345-.345A.353.353,0,0,0,38.971,344.6Z",
  transform: "translate(-19.266 -325.528)",
  className: "primary",
  fill: "#4e4e4e"
})));

var SvgMist = function SvgMist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.283,
    height: 24,
    viewBox: "0 0 23.283 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mist.d8590501.svg";
export { ForwardRef as ReactComponent };